/**
 * GRAFİK TERCİHLERİ (kullanıcı, 12.10.2026: "grafiğe geri döndüğümde son 1 yıl
 * seçiyor, yaptığım tercihleri hatırlamalı").
 *
 * Sunum tercihi (`localStorage`, para birimi tercihinin yanında): hangi dönem
 * ya da hangi iki tarih, hangi grafikler açık. Portföy bilgisi TAŞIMAZ.
 *
 * Hazır dönem seçildiyse dönemin KENDİSİ saklanır, tarihleri değil: "Bu ay"
 * ertesi ay açılınca yeni ayı gösterir. Özel aralık iki tarihiyle saklanır.
 * Bozuk ya da bilinmeyen kayıt sessizce varsayılana düşer: Son 1 yıl; DAR
 * EKRANDA (telefon, menünün "Menü" düğmesine geçtiği < 768 px) Son 6 ay
 * (kullanıcı, 12.10.2026). Kayıtlı tercih varsayılanın önüne geçer.
 */

import type { IsoDate } from "@parafon/contracts";
import { DONEMLER, donemAraligi, type DonemKodu } from "./tarihDonemleri";

export const GRAFIK_TERCIH_ANAHTARI = "parafon.grafikTercihleri";

export interface GrafikTercihleri {
  /** Hazır dönem; null = özel aralık (`from`/`to`). */
  readonly donem: DonemKodu | null;
  readonly from: IsoDate;
  readonly to: IsoDate;
  /** Görünüm: hangi grafikler açık (en az biri). */
  readonly tutar: boolean;
  readonly yuzde: boolean;
}

const ISO = /^\d{4}-\d{2}-\d{2}$/;

/** Telefon genişliği: Tailwind `md` sınırının altı (kabuk da bu sınırda değişir). */
export function darEkranMi(): boolean {
  try {
    return globalThis.matchMedia?.("(max-width: 767.98px)").matches === true;
  } catch {
    return false;
  }
}

export function varsayilanTercihler(bugun: IsoDate, dar = darEkranMi()): GrafikTercihleri {
  const donem: DonemKodu = dar ? "son-6-ay" : "son-1-yil";
  return { donem, ...donemAraligi(donem, bugun), tutar: true, yuzde: true };
}

export function grafikTercihleriniOku(bugun: IsoDate, dar = darEkranMi()): GrafikTercihleri {
  const v = varsayilanTercihler(bugun, dar);
  let ham: unknown;
  try {
    ham = JSON.parse(globalThis.localStorage?.getItem(GRAFIK_TERCIH_ANAHTARI) ?? "null");
  } catch {
    return v;
  }
  if (typeof ham !== "object" || ham === null) return v;
  const o = ham as Record<string, unknown>;
  let tutar = o["tutar"] !== false;
  let yuzde = o["yuzde"] !== false;
  if (!tutar && !yuzde) tutar = yuzde = true;
  const kod = DONEMLER.find((d) => d.kod === o["donem"])?.kod;
  if (kod !== undefined) return { donem: kod, ...donemAraligi(kod, bugun), tutar, yuzde };
  const from = o["from"];
  const to = o["to"];
  if (typeof from === "string" && typeof to === "string" && ISO.test(from) && ISO.test(to) && from <= to) {
    return { donem: null, from, to: to > bugun ? bugun : to, tutar, yuzde };
  }
  return { ...v, tutar, yuzde };
}

export function grafikTercihleriniYaz(t: GrafikTercihleri): void {
  try {
    globalThis.localStorage?.setItem(GRAFIK_TERCIH_ANAHTARI, JSON.stringify(t));
  } catch {
    /* depolama kapalı: tercih bu oturumda kalır */
  }
}

/**
 * KİLİTTEN SONRA "1 YIL" (kullanıcı, 15.10.2026): kasa parolayla ya da
 * kurtarma ifadesiyle açıldığında Günlük Analiz'in dönemi Son 1 yıl olur
 * (telefonda da). Görünüm (hangi grafikler açık) korunur. Kısa süreli
 * oturumla parolasız yeniden yükleme bir kilit değildir; ona dokunulmaz.
 */
export function kilittenSonraDonemiSifirla(bugun: IsoDate): void {
  const t = grafikTercihleriniOku(bugun);
  grafikTercihleriniYaz({ ...t, donem: "son-1-yil", ...donemAraligi("son-1-yil", bugun) });
}
